<template>
  <div style="height: 100%; width: 100%;">
    <el-menu :default-active="this.$router.currentRoute.path == '/admin/organization' ? '/admin/organization/users' : this.$router.currentRoute.path" :router="true" mode="horizontal">
      <el-menu-item index="/admin/organization/users">Users</el-menu-item>
      <el-menu-item
        v-if="$store.getters.hasPermission(['All', 'Web'])"
        index="/admin/organization/positions"
      >Positions</el-menu-item>
      <el-menu-item
        v-if="$store.getters.hasPermission(['All', 'Web'])"
        index="/admin/organization/units"
      >Units</el-menu-item>
      <el-menu-item
        v-if="$store.getters.hasPermission(['All', 'Web'])"
        index="/admin/organization/ranks"
      >Ranks</el-menu-item>
    </el-menu>
    <div style="margin: 16px;">
<el-card shadow="hover" >
      <router-view></router-view>
</el-card>
    </div>
  </div>
</template>

<script>
export default {
    created() {
        if (this.$router.currentRoute.path == "/admin/organization")
            this.$router.push("/admin/organization/users");
    }
};
</script>
